import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  uploadedData: any;
  uploadedFile: any;

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, headers: string[]): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    let sheetPro: any = {};
    sheetPro = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
    if (excelFileName == 'Alarm_Routes') {  // NOSONAR
      sheetPro = { Sheets: { 'Alarm_Routes': worksheet }, SheetNames: ['Alarm_Routes'] };
    }
    else if (excelFileName == 'Alarms_Summary') {  // NOSONAR
      sheetPro = { Sheets: { 'Alarms_Summary': worksheet }, SheetNames: ['Alarms_Summary'] };
    }

    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);

    //setting headers
    for (let C = range.s.c; C <= range.e.c; C++) {
      const address = XLSX.utils.encode_col(C) + '1'; // <-- first row
      if (!worksheet[address]) {continue;}
      worksheet[address].v = headers[C];
    }
    const wscols: any[] = [];
    for (const head of headers) {  // columns length added      
      wscols.push({ wch: head.length + 5 });
    }
    worksheet['!cols'] = wscols;

    const workbook: XLSX.WorkBook = sheetPro;
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });     
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  getUploadedData() {
    return this.uploadedData;
  }

}
